import React from 'react';
import { FDPrimaryActionButton } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { dataAttrs } from 'Helpers/Testing';

export const AuthenticationSubmitButton = () => {
  const { resource, onSubmit } = useMetaLayoutContext();

  return (
    <FDPrimaryActionButton
      isFullWidth
      {...dataAttrs('submit-btn', resource)}
      onClick={onSubmit}
      label={resource.attr('primaryActionLabel')}
    />
  );
};
